import { useMemo } from 'react';
import { Box, Typography, useScreenClass } from '@vp/swan';
import { __ } from '@99designs/i18n';

// Each branch returns a complete, standalone greeting phrase (rather than a bare
// time-of-day word slotted into a shared template) so translators have the full
// grammatical context — some locales order or inflect "morning"/"afternoon"/"evening"
// differently depending on what precedes it.
// Note: `_context` must be inlined into each `__()` call (not hoisted into a shared
// const) — the extractor can't resolve a referenced value, only a literal.
function getTimeOfDayGreeting(): string {
    const hour = new Date().getHours();
    if (hour < 12) {
        return __('Good morning,', {
            _context:
                'First line of a two-line greeting title on the chat brief landing hero, inviting the customer to start their design brief.',
        });
    }
    if (hour < 18) {
        return __('Good afternoon,', {
            _context:
                'First line of a two-line greeting title on the chat brief landing hero, inviting the customer to start their design brief.',
        });
    }
    return __('Good evening,', {
        _context:
            'First line of a two-line greeting title on the chat brief landing hero, inviting the customer to start their design brief.',
    });
}

export function LandingHero() {
    const greeting = useMemo(() => getTimeOfDayGreeting(), []);
    const screenClass = useScreenClass();
    const isMobile = screenClass === 'xs';

    return (
        <Box
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <Box>
                <img
                    src="https://cms.cloudinary.vpsvc.com/image/upload/f_auto,q_auto/expert_services/Brief/Chat%20Brief/LandingGraphic.png"
                    alt={__('Design brief illustration')}
                    style={{
                        width: isMobile ? '100px' : '140px',
                        height: 'auto',
                    }}
                />
            </Box>

            <Typography
                as="h1"
                fontSkin="title-headline"
                style={{
                    textAlign: 'center',
                    maxWidth: '434px',
                    margin: `0 0 ${isMobile ? '24px' : '32px'}`,
                }}
            >
                {greeting}
                <br />
                {__("let's build your design brief")}
            </Typography>
        </Box>
    );
}
